import { ProductTagBase } from '../ProductTagBase';
import klass from '../style/ProductTag.module.scss';

export class QuantityLimitedTag extends ProductTagBase<number> {
  protected makeLabel(): string | undefined {
    const count = this.data.value;
    if (count > 0 && count < 100) {
      return ET('mps2::product::tag::quantity_limited', { count, lng: this.data.lang });
    } else {
      return undefined;
    }
  }

  protected styles(): string {
    return klass.limited;
  }

  isTimerNeeded(): boolean {
    return false;
  }
}
